export const BLACK = '#333333';
export const RED = '#8D0000';
export const GOLD = '#FFB800';
export const GREY = '#787878';
export const LIGHTGREY = '#F6F6F6';
export const BABYGREY = '#AAAAAA';
export const PINK = '#F2E2E2';
export const WHITE = '#FFFFFF';
